module.exports = __webpack_public_path__ + "static/media/Banali.48cbb2f6.jpg";